<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.5 9L7.66795 7.5547C8.1718 7.2188 8.8282 7.2188 9.33205 7.5547L10.6679 8.4453C11.1718 8.7812 11.8282 8.7812 12.3321 8.4453L14.5 7"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M5.5 13L7.66795 11.5547C8.1718 11.2188 8.8282 11.2188 9.33205 11.5547L10.6679 12.4453C11.1718 12.7812 11.8282 12.7812 12.3321 12.4453L14.5 11"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    /></svg>
</template>

<script>
export default {
  name: 'MeanIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
